import { createFeatureFlagHooks } from './useFeatureFlag';
import {
  useFeatureFlagBase,
  useTenantFeatureFlagBase,
} from './useFeatureFlagBase';

export const { useFeatureFlag, useFeatureFlagEnabled } =
  createFeatureFlagHooks(useFeatureFlagBase);

export const { useFeatureFlagEnabled: useTenantFeatureFlagEnabled } =
  createFeatureFlagHooks(useTenantFeatureFlagBase);

export { useSetFeatureFlag } from './useSetFeatureFlag';
export { FeatureFlagDevProvider } from './FeatureFlagDevProvider';
export { FeatureFlagDevContext } from './FeatureFlagDevContext';
